import * as React from "react";

export const ContentSection = (
  props: React.HTMLAttributes<HTMLElement> & { children?: React.ReactNode }
): JSX.Element => {
  const { children, className, ...rest } = props;
  const base = "px-[15%] py-[50px] bg-white";
  const combined = className ? `${base} ${className}` : base;

  return (
    <section className={combined} {...rest}>
      {children}
    </section>
  );
};
